var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import icons from "../../utils/Icons";
import PrimaryButton from "../Button/PrimaryButton";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../Spinner";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import useExtractUnion from "../../hooks/useExtractUnion";
var AddUnionModal = function (_a) {
    var closeModal = _a.closeModal, onSubmit = _a.onSubmit, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var modalRef = useRef(null);
    var cardImageRef = useRef(null);
    var _c = useState(""), unionNo = _c[0], setUnionNo = _c[1];
    var _d = useState(null), cardImage = _d[0], setCardImage = _d[1];
    var _e = useState(""), cardImageSrc = _e[0], setCardImageSrc = _e[1];
    var _f = useExtractUnion(), extractUnion = _f.extractUnion, extracting = _f.loading;
    var canSubmit = !extracting && unionNo.trim() !== "" && cardImage !== null;
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [closeModal]);
    var submitAction = function () {
        if (cardImage === null) {
            toast.error("Please upload a picture of your union card");
            return;
        }
        if (extracting) {
            toast.error("Still reading your card. Please wait a moment.");
            return;
        }
        if (unionNo.trim() === "") {
            toast.error("Could not read a union number from the card. Please try a clearer photo.");
            return;
        }
        onSubmit(unionNo.trim(), cardImage);
    };
    return (_jsxs("div", { ref: modalRef, className: "absolute flex-1 top-0 right-0 left-0 z-10 justify-center px-4", children: [_jsx(ToastContainer, { position: "top-right" }), _jsxs("div", { className: "bg-white my-12 relative w-full lg:w-[40%] lg:mx-auto rounded-xl border-[#00000014] outline-none p-4 opacity-100 shadow-[0_8px_12px_0_rgba(47,43,67,0.2)] border-t-[1px] border-t-[rgba(47,43,67,0.1)]", children: [_jsx("button", { onClick: function () { return closeModal(); }, className: "text-slate-700 absolute top-[12px] right-[12px]", children: _jsx("img", { src: icons.closeBlack, alt: "" }) }), _jsx("div", { className: "mt-2", children: _jsx("h3", { className: "text-left text-[18px] font-semibold", children: "Add Union Number" }) }), _jsx("div", { className: "text-red-500 text-sm", children: _jsx("div", { className: "my-4", children: _jsx("p", { children: "Upload a picture of your union card to verify your membership." }) }) }), unionNo !== "" && (_jsxs("div", { className: "my-4", children: [_jsx("p", { className: "mb-2 text-[15px] font-[500]", children: "Union Number" }), _jsx("div", { className: "inline-block px-4 py-2 bg-[#EEF4FF] border border-[#5898FD] rounded-md text-[16px] font-semibold text-[#5898FD]", children: unionNo })] })), _jsx("div", { className: "mb-3 text-[15px] font-[500]", children: _jsxs("div", { className: "flex items-center gap-2", children: ["Union Card Image", _jsxs("label", { htmlFor: "union-card-upload", className: "flex items-center gap-2 px-4 py-2 bg-[#5898FD] text-white rounded-md cursor-pointer", children: ["Upload", _jsx(FileUploadIcon, {})] })] }) }), _jsx("div", { className: "flex items-center gap-2", children: _jsx("input", { id: "union-card-upload", type: "file", accept: "image/*", className: "hidden", onChange: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                var file, reader, result;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
                                            if (!file)
                                                return [2 /*return*/];
                                            setCardImage(file);
                                            reader = new FileReader();
                                            reader.onload = function () {
                                                setCardImageSrc(reader.result);
                                            };
                                            reader.readAsDataURL(file);
                                            setUnionNo("");
                                            return [4 /*yield*/, extractUnion(file)];
                                        case 1:
                                            result = _b.sent();
                                            if (result.ok === true) {
                                                setUnionNo(result.data.unionNo);
                                            }
                                            else {
                                                toast.error(result.error);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }) }), _jsx("div", { className: "mt-4 flex items-center gap-3", children: _jsx("div", { ref: cardImageRef, className: "w-full flex items-center justify-center overflow-hidden rounded-[8px] border-2 border-[#5898FD] border-dashed", children: _jsx("img", { className: "object-cover w-full h-full", src: cardImageSrc !== "" ? cardImageSrc : "/chaseit/img/card_placeholder.jpg", alt: "Union Card Placeholder" }) }) }), _jsx("div", { className: "my-4", children: loading ? (_jsx(Spinner, {})) : (_jsx(PrimaryButton, { title: extracting ? "Reading card…" : "Add", classes: "bg-[#5898FD] text-white w-full py-2 ".concat(!canSubmit ? 'opacity-50 cursor-not-allowed' : ''), clickHandle: function () { return submitAction(); }, disabled: !canSubmit })) })] })] }));
};
export default AddUnionModal;
